export default "__VITE_ASSET__31485fe3__"